import templateStr from 'text!./templates/AMABinaryRadio.html';

export default [function () {
    return {
        restrict: 'AE',
        template: templateStr,
        transclude: false,
        scope: {
            model: '=?',
            name: '@',
            onNoClick: '&?',
            onYesClick: '&?',
            disable: '@?'

        },
        controller: ['$scope', function ($scope) {
            //console.log($scope.model);
        }]
    };
}];


//////////////////
// WEBPACK FOOTER
// ./app/customer/js/src/edge/platform/widgets/inputs/AMABinaryRadio.js
// module id = 768
// module chunks = 0